// API service for SAT catalogs
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class SatCatalogService {
  // Get regimen fiscal catalog
  static async getRegimenFiscalCatalog(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/sat-catalogs/regimen-fiscal`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching regimen fiscal catalog:', error);
      throw error;
    }
  }

  // Get uso CFDI catalog
  static async getUsoCfdiCatalog(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/sat-catalogs/uso-cfdi`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching uso CFDI catalog:', error);
      throw error;
    }
  }

  // Get all SAT catalogs
  static async getAllSatCatalogs(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/sat-catalogs`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching SAT catalogs:', error);
      throw error;
    }
  }
}

export default SatCatalogService;
